export const Section = Object.freeze({
    INVESTMENT_GOALS: {
        name: 'INVESTMENT_GOALS',
        cssClassName: 'investment-goals',
        index: 1,
    },
    INVESTMENT_STRATEGY: {
        name: 'INVESTMENT_STRATEGY',
        cssClassName: 'investment-strategy',
        index: 2,
    },
    RISK_TOLERANCE: {
        name: 'RISK_TOLERANCE',
        cssClassName: 'risk-tolerance-questions',
        index: 3,
    },
    RISK_TOLERANCE_EVALUATION: {
        name: 'RISK_TOLERANCE_EVALUATION',
        cssClassName: 'risk-tolerance-evaluation',
        index: 4,
    },
    THEME: {
        name: 'THEME',
        cssClassName: 'theme',
        index: 5,
    },
    INVESTMENT_PROPOSAL: {
        name: 'INVESTMENT_PROPOSAL',
        cssClassName: 'investment-proposal',
        index: 6,
    },
    APPOINTMENT: {
        name: 'APPOINTMENT',
        index: 7,
    },
});

export const RiskToleranceEvaluationOption = Object.freeze({
    ACCEPT_RISK: 'ACCEPT_RISK',
    ACCEPT_RECOMMENDATION: ' ACCEPT_RECOMMENDATION',
});

export const ScreenSource = Object.freeze({
    WEB_APP_MOBILE: 'AMV',
});
